import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_SEAT_MAP_ELEMENT,
  CLEAR_SEAT_MAP_ELEMENTS,
  FLAG_GETTING_SEAT_MAP_ELEMENT,
  FLAG_GETTING_SEAT_MAP_ELEMENTS,
  GET_SEAT_MAP_ELEMENT,
  GET_SEAT_MAP_ELEMENTS,
} from '../types';
import { SEAT_MAP_ELEMENT_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_PUT_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { SEAT_MAP_ELEMENT_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingSeatMapElements = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_SEAT_MAP_ELEMENTS,
  });

const getSeatMapElements = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingSeatMapElements(true));
    const query = tableFilters;
    const url = `${SEAT_MAP_ELEMENT_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_SEAT_MAP_ELEMENTS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingSeatMapElements(false));
  }
};

const clearSeatMapElements = () => (dispatch) =>
  dispatch({ type: CLEAR_SEAT_MAP_ELEMENTS });

const flagGettingSeatElement = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_SEAT_MAP_ELEMENT,
  });

const getSeatElement = async ({seatMapElementId}) => async (dispatch) => {
  try {
    dispatch(flagGettingSeatElement(true));
    const url = `${SEAT_MAP_ELEMENT_ENDPOINT}/${seatMapElementId}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_SEAT_MAP_ELEMENT,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingSeatElement(false));
  }
};

const createNewSeatElement = async ({
  name,
  description,
  elementIcon,
  isSeat
}) => {
  const payload = {
    name,
  description,
  elementIcon,
  isSeat
  };
  const url = SEAT_MAP_ELEMENT_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const seatMapElement= await promise.json();
  return seatMapElement
};

  const postSeatElement =
    async ({
      name,
  description,
  elementIcon,
  isSeat
    }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingSeatElement(true));
        const response = await createNewSeatElement({
          name,
  description,
  elementIcon,
  isSeat
        });
        if (response) {
          dispatch(push(`${SEAT_MAP_ELEMENT_PATH}/${response.id}`));
        }
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingSeatElement(false));
      }
    };

    const putSeatElement =
  async (
    seatMapElementId,
    {
      name,
  description,
  elementIcon,
  isSeat
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSeatElement(true));
      const payload = {
        id: seatMapElementId,
        name,
  description,
  elementIcon,
  isSeat
      };
      const url = `${SEAT_MAP_ELEMENT_ENDPOINT}/${seatMapElementId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${SEAT_MAP_ELEMENT_PATH}/${seatMapElementId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingSeatElement(false));
    }
  };

  const deleteSeatElement =
  async ({ seatMapElementId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSeatElement(true));
      const url = `${SEAT_MAP_ELEMENT_ENDPOINT}/${seatMapElementId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(SEAT_MAP_ELEMENT_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingSeatElement(false));
    }
  };

const clearSeatElement = () => (dispatch) =>
  dispatch({ type: CLEAR_SEAT_MAP_ELEMENT });

export { getSeatMapElements, clearSeatMapElements, getSeatElement, clearSeatElement, postSeatElement, putSeatElement, deleteSeatElement };
